import { Row, Col } from 'antd';
import React, { FC } from 'react';

type Props = {
  padding: string | undefined;
  textLeft: string;
  textRight?: string;
  fontRight?: string;
  fontLeft?: string;
  isBorder?: boolean;
  typeGrid?: number;
  isRequire?: boolean;
  whiteSpaceRight?: boolean;
};

const Text: FC<Props> = ({
  isRequire = false,
  typeGrid = 0,
  padding,
  textLeft,
  textRight,
  fontRight = 'smallBoldFont',
  fontLeft = 'smallFont',
  isBorder = true,
  whiteSpaceRight,
  children,
}) => {
  const border = isBorder ? '1px solid #dddddd' : '';

  return (
    <div>
      <Row style={{ padding: `${padding}`, borderBottom: `${border}` }}>
        <Col className={`${fontLeft} d-flex ${textRight ? 'alignCenter' : 'mt-7'}`} span={typeGrid === 0 ? 6 : 4}>
          {textLeft}
          {isRequire ? <span style={{ color: 'red' }}>※</span> : ''}
        </Col>
        {textRight ? (
          <Col
            className={`${fontRight} d-flex alignCenter ${whiteSpaceRight && 'white-space'}`}
            span={typeGrid === 0 ? 18 : 20}
          >
            {textRight}
          </Col>
        ) : (
          children
        )}
      </Row>
    </div>
  );
};

export default Text;
